.compareModal.compareModal {
  max-width: 1312px;
  height: var(--modal-standard-size);
}

/* Modal.Content override: single scroll container for both directions */
.modalScrollContainer {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

/* ===== Table ===== */
.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  height: 100%;
}

.spacerRow {
  height: 100%;
}

.table th,
.table td {
  padding: 14px 20px;
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid var(--colors-grays-light);
  font-size: 14px;
  color: var(--colors-grays-black);
}

/* ===== Sticky thead ===== */
.thead {
  position: sticky;
  top: 0;
  z-index: 5;
}

.thead th {
  background: var(--colors-grays-white);
  text-align: center;
  vertical-align: top;
  padding: 20px 16px;
  border-bottom: 2px solid var(--colors-grays-light);
}

/* ===== Label column ===== */
.labelCell {
  width: 140px;
  min-width: 140px;
  font-weight: 600;
  color: var(--colors-grays-black);
  white-space: nowrap;
  vertical-align: middle;
  text-align: left;
}

.productCol {
  min-width: 200px;
}

/* ===== Product header cells ===== */
.productImg {
  width: 120px;
  height: 120px;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  background: var(--colors-grays-ultralight);
  margin: 0 auto 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.productImg .productImgLink,
.productImg .productImgLink > * {
  display: block;
  width: 100%;
  height: 100%;
}

.removeBtn {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: var(--colors-grays-mid);
  transition: background 0.15s;
}

.removeBtn:hover {
  background: var(--colors-grays-white);
  color: var(--colors-grays-dark);
}

.productName {
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  height: 24px;
  margin: 0;
  width: 100%;
}

.productName:hover {
  text-decoration: underline;
}

.tfoot td {
  border-top: 2px solid var(--colors-grays-light);
  border-bottom: none;
  padding: 16px 20px;
  text-align: center;
  vertical-align: middle;
}

.table tbody td {
  text-align: center;
  color: var(--colors-grays-black);
}

.table .spacerRow td {
  padding: 0;
  border: none;
  background: var(--colors-grays-white);
}

.table tbody td:first-child {
  text-align: left;
}

.tfoot tr {
  background: var(--colors-grays-white);
}

.table tbody tr {
  --compare-pill-bg: var(--colors-grays-ultralight);
}

.table tbody tr:nth-child(odd) {
  --compare-pill-bg: var(--colors-grays-white);

  background: var(--colors-grays-ultralight);
}

/* ===== Price styling ===== */
.salePrice {
  color: var(--colors-primary-dark);
}

/* ===== Rating ===== */
.ratingWrap {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
}

/* ===== Pills ===== */
.pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px 4px 6px;
  border-radius: 100px;
  background: var(--compare-pill-bg, var(--colors-grays-ultralight));
  border: 1px solid var(--colors-grays-light);
  white-space: nowrap;
}

.pillIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}

/* ===== Sticky tfoot ===== */
.tfoot {
  position: sticky;
  bottom: 0;
  z-index: 4;
}

.table .labelCell,
.thead .labelCell,
.tfoot .labelCell {
  position: sticky;
  left: 0;
  z-index: 2;
  background: var(--colors-grays-white);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  clip-path: inset(0 -10px 0 0);
}

@supports (animation-timeline: scroll()) {
  .table .labelCell,
  .thead .labelCell,
  .tfoot .labelCell {
    animation: compareLabelShadow linear both;
    animation-timeline: scroll(nearest inline);
    animation-range: 0 8px;
  }

  @keyframes compareLabelShadow {
    from {
      box-shadow: none;
    }

    to {
      box-shadow: 3px 0 6px rgb(0 0 0 / 10%);
    }
  }
}

.tfoot .labelCell {
  background: var(--colors-grays-white);
}

.table tbody tr:nth-child(odd) .labelCell {
  background: var(--colors-grays-ultralight);
}

/* ===== Mobile responsive ===== */
@media (--reefer-media-tablet-max) {
  .table {
    table-layout: auto;
  }

  /* Force the first (label) column to a narrow fixed width so it doesn't
     crowd out the first product column on mobile. <col> width is honored
     even in auto layout, unlike width on individual cells. */
  .labelCol {
    width: 80px;
  }

  .table th,
  .table td {
    padding: 10px;
    font-size: 13px;
    min-width: 210px;
  }

  .thead th {
    padding: 14px 10px;
  }

  .table .labelCell,
  .thead .labelCell,
  .tfoot .labelCell {
    min-width: 0;
    font-size: 11px;
    padding: 8px 10px;
  }

  .productImg {
    width: 72px;
    height: 72px;
    aspect-ratio: 1 / 1;
  }

  .ratingWrap {
    flex-direction: column;
    gap: 2px;
  }

  .pill {
    font-size: 12px;
    padding: 3px 10px 3px 6px;
    gap: 4px;
    white-space: nowrap;
  }

  .tfoot td {
    padding: 12px 10px;
  }
}
